const staticBasePath = window.feConfig.common.staticBaseUrl;
// 公共CDN资源地址
export const remoteCdn = staticBasePath + 'ufd/55a3e0/ote';
// 老的mediasvg迁移后的地址
export const SvgMediaUrl = remoteCdn + '/pc/other/ote/svg';

// 新的mediasvg地址
export const SvgMediaNewUrl = remoteCdn + '/pc/svg';

export const cdnMedia = remoteCdn + '/pc/other/';

export const SvgMediaUrlCommon = staticBasePath + 'ufd/3f5568/common/pc_backstage/svg';
export const SvgMediaUrlFrontCommon = staticBasePath + 'ufd/3f5568/common/pc_foreground/svg';

// 文件转码状态
export const TranscodingStatus = {
  wait: 0, // 等待中
  going: 1, // 进行中
  success: 2, // 已完成
  fail: 3 // 失败
};

// 附件的上传状态
export const UploadStatus = {
  going: 1,
  success: 2,
  fail: 3
};

// 文件
export const EnumFileType = {
  image: 0, // 图片
  file: 1, // 文档
  video: 2, // 视频
  audio: 3 // 音频
};

// 判断题 正确、错误
export const QUES_JUDGE_CHOICE = ['pc_biz_ote_lbl_wrong', 'pc_biz_ote_lbl_wright'];
// 试题题型 0-单选题 1-多选题 2-判断题 3-填空题 4-问答题 5-组合题
export const QUES_TYPE_NAMES = ['pc_biz_ote_lbl_questype0', 'pc_biz_ote_lbl_questype1', 'pc_biz_ote_lbl_questype2', 'pc_biz_ote_lbl_questype3', 'pc_biz_ote_lbl_questype4', 'pc_biz_ote_lbl_questype5'];

// 试题难度 0-易 1-中 2-难
// 试题难度全量 0-易 3-较易 1-中 4-较难 2-难
export const QUES_LEVEL_NAMES = {
  0: 'pc_biz_ote_lbl_easy',
  1: 'pc_biz_ote_lbl_medium',
  2: 'pc_biz_ote_lbl_difficult',
  3: 'pc_biz_ote_lbl_littleeasy',
  4: 'pc_biz_ote_lbl_littledifficult',

  // 实际开启的难易度及其顺序，通常用于筛选等菜单。 全量开启时： 0-易 3-较易 1-中 4-较难 2-难  默认： 0-易 1-中 2-难
  // values: [0, 3, 1, 4, 2],
  values: [0, 1, 2],

  // 全量的难易度，用于展示现有数据的难易度。
  fullValues: [0, 3, 1, 4, 2],
  // 减量的难易度
  simpleValues: [0, 1, 2]
};
QUES_LEVEL_NAMES.values = QUES_LEVEL_NAMES.simpleValues;
export const changeLevelType = (all, cb) => {
  const newValues = all ? QUES_LEVEL_NAMES.fullValues : QUES_LEVEL_NAMES.simpleValues;
  if (newValues !== QUES_LEVEL_NAMES.values) {
    QUES_LEVEL_NAMES.values = newValues;
    cb && typeof (cb) === 'function' && cb();
  }
};
